// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectInterestsOnBalancePlanMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_INTERESTS_ON_BALANCE_PLAN_MESSAGE);
        this.InterestsOnBalancePlanID = 0;
        this.CounterAccountID = 0;
        this.Description = '';
        this.Name = '';
        this.ListInterestsOnBalancePlanEntryBean = [];
    }
}
export class InterestsOnBalancePlanEntryBean {
    constructor() {
        this.AssetID = 0;
        this.Interest = 0;
        this.NegativeInterest = 0;
    }
}
